import React from 'react';
import styles from './style/slider_buttons_style.module.scss';
import PropTypes from 'prop-types'
import IconButton from '../icon-button/IconButton'
import PointProgressBar from '../point-progress-bar/PointProgressBar'
import Foundation from '../../foundations/Foundation'
import { getLanguageDir } from '../../../../store/ui/reducers'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'

const SliderButtons = ({ currentIndex, totalLevels, className='', languageDir, ...props }) => {
    const getCircles = () => {

        return Array.from({ length: totalLevels }, (_, i) => (
            <div
                key={`SliderButtonsBar-${i}`}
                className={`${styles.circle} ${i === currentIndex ? styles.filled : ''}`}
            />
        ));
    };
    
    const isRTL = languageDir === 'rtl'

    return (
        <div className={`${className} ${styles['slider-buttons']}`}>
            <IconButton size-m
                        style-inverse
                        img={isRTL ? "chevron_right" : "chevron_left"}
                        onClick={props.clickLeftButton}
                        className={styles['slider-button']}
            />
            {getCircles()}
            <IconButton size-m
                        style-inverse
                        img={isRTL ? "chevron_left" : "chevron_right"}
                        onClick={props.clickRightButton}
                        className={styles['slider-button']}
            />
        </div>
    )

};

SliderButtons.propTypes = {
    currentIndex: PropTypes.number,
    totalLevels: PropTypes.number,
    className: PropTypes.string,
    clickLeftButton: PropTypes.func,
    clickRightButton: PropTypes.func,
}

SliderButtons.defaultProps = {
    totalLevels: 5,
}

const mapStateToProps = (state) => {
    return {
        languageDir: getLanguageDir(state)
    }
}

export default injectIntl(connect(mapStateToProps, null)(SliderButtons));
